import React, { useState } from "react";
import { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import "../../../styles/AddEditModel.scss";
import AlertModel from "../../AlertModel";
import { baseURL } from "../../BaseUrl";
import Select from "react-select";

// import { travelizeAuth } from "../HeaderAuthentication";

export default function EditRole(props) {
  let userDetails = JSON.parse(sessionStorage.getItem("usdtls"));

  const travelizeAuth = {
    "Content-Type": "application/json",
    Travelize_Authentication: userDetails,
  };

  const [roleList, setRoleList] = useState([]);
  const [roleName, setRoleName] = useState("");
  const [subscriptionId, setSubscriptionId] = useState("");
  const [roleDescription, setRoleDescription] = useState("");
  const [reportingRole, setReportingRole] = useState(0);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    alertType: null,
    message: null,
  });

  const closeAlertModel = () => {
    setShowAlert(!showAlert);
  };

  useEffect(() => {
    fetchRoleDropdown();
  }, [props.editRoleId]);

  const fetchRoleDropdown = () => {
    let requestOption = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(`${baseURL}/api/Role/BindRolesDropDown`, requestOption)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setRoleList(
            res.result.map((data) => {
              return { value: data.roleID, label: data.roleName };
            })
          );
        } else {
          setRoleList([]);
        }
      });
    fetch(`${baseURL}/api/Role/Get/${props.editRoleId}`, requestOption)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setSubscriptionId(res.result.subscriptionID);
          setRoleName(res.result.roleName);
          setRoleDescription(res.result.roleDesciption);
          setReportingRole(res.result.reportingRoleID);
          // setEnableStatus(res.result);
        } else {
          setRoleName("");
          setRoleDescription("");
        }
      });
  };

  const [reportingRoleName, setReportingRoleName] = useState("");

  useEffect(() => {
    if (reportingRole !== null) {
      roleList.map((role) => {
        if (reportingRole == role.value) {
          setReportingRoleName(role);
        }
      });
    }
  }, [roleList, reportingRole]);

  const editroles = () => {
    const roleDetails = {
      subscriptionID: subscriptionId,
      roleID: props.editRoleId,
      roleName: roleName,
      roleDesciption: roleDescription,
      reportingRoleID: reportingRole,
    };

    let requestOption = {
      method: "POST",
      mode: "cors",
      headers: travelizeAuth,
      body: JSON.stringify(roleDetails),
    };
    fetch(`${baseURL}/api/Role/UpdateRole`, requestOption)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setShowAlert(true);
          setAlertMessage({
            alertType: "success",
            message: res.message,
          });
          setTimeout(() => {
            props.handleClose();
            props.fetchRoleswithReporting();
          }, 1000);
        } else {
          setShowAlert(true);
          setAlertMessage({
            alertType: "fails",
            message: res.errorMessage,
          });
        }
      });
  };

  return (
    <div>
      <Modal
        show={props.editRoleModel}
        onHide={props.handleClose}
        className="main_model add-edit-model"
      >
        <div className="add-edit-heading">
          <h6 className="add-edit-head">EDIT ROLE</h6>
          <i className="fa fa-times" onClick={props.handleClose} />
        </div>
        <form>
          <div className="container add-edit">
            <div className="model-inputs">
              <div className="mb-2">
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control form add-input"
                  placeholder="Role Name"
                  value={roleName}
                  onChange={(e) => setRoleName(e.target.value)}
                />
              </div>

              <div className="mb-2">
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control form add-input"
                  placeholder="Role Description"
                  value={roleDescription}
                  onChange={(e) => setRoleDescription(e.target.value)}
                />
              </div>

              <div className="mb-2">
                <Select
                  className="select-add-user-model"
                  options={roleList}
                  placeholder="Reporting to"
                  value={reportingRoleName}
                  onInputChange={roleList.label}
                  onChange={(data) => setReportingRole(data.value)}
                  isSearchable={true}
                />
              </div>
            </div>
          </div>
        </form>
        <div className="btns-save-cancel">
          <div className="model-save-button">
            <button
              onClick={editroles}
              type="button"
              className="btn btn-save-up"
              data-bs-dismiss="modal"
            >
              Save
            </button>
          </div>
          <div className="model-cancel-button">
            <button
              onClick={props.handleClose}
              type="button"
              className="btn btn-cancel"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <>
        {showAlert ? (
          <AlertModel
            showAlert={showAlert}
            alertMessage={alertMessage}
            closeAlertModel={closeAlertModel}
          />
        ) : (
          ""
        )}
      </>
    </div>
  );
}
